// extracted by mini-css-extract-plugin
module.exports = {"TermsDescription":"Terms_TermsDescription__2qTeb"};